export default __webpack_public_path__ + "static/media/totals_bg_mobile.1be33605.svg";